module.exports = __webpack_public_path__ + "static/img/lrs_yuyanjia_img@2x.9659ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lrsimages/rules/lrs_yuyanjia_img@2x.png
// module id = nxEC
// module chunks = 23